var domain = {
    appname: "93直播",
    version: 141,
    aliyun: "https://f7tv.oss-accelerate.aliyuncs.com/domain.config",
    tencent: "https://livejk-1309827338.cos.accelerate.myqcloud.com/domain.config",
    domains: [
        "https://jk.tgrfst.cc",
        "https://jk.tadasg.cn",
        "https://jk.tgxaszx.cn",
        "https://jk.tgtyujh.cn",
        "https://jk.tgokmh.cn"
    ],
    tabLineColoor: '#171616',
    tabColor: '#A4B8CB',
    tabSelColor: '#171616',
    channelid: 5,
    freeLanchannelid: 5,
    appID: 'com.tgtv.livetv',
    serviceAgreement: "download/serviceAgreement_tg.html",
    imApi: [
        "https://frljk.im1q.cn",
        "https://frljk.bgmim.cn",
        "https://frljk.imtgb.cn",
        "https://frljk.im2w.cn",
        "https://frljk.56im.cn"
    ],
    imAliyun: "https://freelantv.oss-accelerate.aliyuncs.com/domain.config",
    imTencent: "https://freelanjk-1309827338.cos.accelerate.myqcloud.com/domain.config",
    showDownload: true,
}

export default domain;